









































































































































































































































import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'PanelMenuGetMeBackLogo',
  props: {
    lang: {
      type: String as PropType<'ru' | 'en'>,
      default: 'ru',
    },
  },
});
